// extracted by mini-css-extract-plugin
module.exports = {"info-popup":"InfoPopup_info-popup__vAU3z"};